export default {
  name: "es",
  el: {
    breadcrumb: {
      label: "Breadcrumb",
    },
    colorpicker: {
      confirm: "Confirmar",
      clear: "Despejar",
    },
    datepicker: {
      now: "Ahora",
      today: "Hoy",
      cancel: "Cancelar",
      clear: "Despejar",
      confirm: "Confirmar",
      selectDate: "Seleccionar fecha",
      selectTime: "Seleccionar hora",
      startDate: "Fecha inicial",
      startTime: "Hora inicial",
      endDate: "Fecha final",
      endTime: "Hora final",
      prevYear: "Año anterior",
      nextYear: "Próximo año",
      prevMonth: "Mes anterior",
      nextMonth: "Próximo mes",
      year: "año",
      month1: "enero",
      month2: "febrero",
      month3: "marzo",
      month4: "abril",
      month5: "mayo",
      month6: "junio",
      month7: "julio",
      month8: "agosto",
      month9: "septiembre",
      month10: "octubre",
      month11: "noviembre",
      month12: "diciembre",
      week: "semana",
      weeks: {
        sun: "DOM",
        mon: "LUN",
        tue: "MAR",
        wed: "MIÉ",
        thu: "JUE",
        fri: "VIE",
        sat: "SÁB",
      },
      months: {
        jan: "ENE",
        feb: "FEB",
        mar: "MAR",
        apr: "ABR",
        may: "MAY",
        jun: "JUN",
        jul: "JUL",
        aug: "AGO",
        sep: "SEP",
        oct: "OCT",
        nov: "NOV",
        dec: "DIC",
      },
    },
    select: {
      loading: "Cargando",
      noMatch: "No hay coincidencias",
      noData: "Sin datos",
      placeholder: "Seleccionar",
    },
    mention: {
      loading: "Cargando",
    },
    cascader: {
      noMatch: "No hay coincidencias",
      loading: "Cargando",
      placeholder: "Seleccionar",
      noData: "Sin datos",
    },
    pagination: {
      goto: "Ir a",
      pagesize: "/página",
      total: "Total {total}",
      pageClassifier: "",
      page: "Página",
      prev: "Página anterior",
      next: "Página siguiente",
      currentPage: "página {pager}",
      prevPages: "{pager} páginas anteriores",
      nextPages: "{pager} páginas siguientes",
    },
    messagebox: {
      title: "Mensaje",
      confirm: "Aceptar",
      cancel: "Cancelar",
      error: "La entrada contiene caracteres no permitidos",
    },
    upload: {
      deleteTip: "haz clic en eliminar para quitar",
      delete: "Eliminar",
      preview: "Vista previa",
      continue: "Continuar",
    },
    table: {
      emptyText: "Sin datos",
      confirmFilter: "Confirmar",
      resetFilter: "Restablecer",
      clearFilter: "Todo",
      sumText: "Suma",
    },
    tour: {
      next: "Siguiente",
      previous: "Volver",
      finish: "Finalizar",
    },
    tree: {
      emptyText: "Sin datos",
    },
    transfer: {
      noMatch: "No hay coincidencias",
      noData: "Sin datos",
      titles: ["Lista 1", "Lista 2"],
      filterPlaceholder: "Escribe una frase de búsqueda",
      noCheckedFormat: "total: {total}",
      hasCheckedFormat: "seleccionados: {checked}/{total}",
    },
    image: {
      error: "ERROR",
    },
    pageHeader: {
      title: "Volver",
    },
    popconfirm: {
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    },
    carousel: {
      leftArrow: "Flecha izquierda del carrusel",
      rightArrow: "Flecha derecha del carrusel",
      indicator: "Cambiar el carrusel al índice {index}",
    },
  },
};
